import React from 'react'
import { Dialog, DialogContent } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { LOAD_RADAR_COLORS as C } from '../constants/colors'

interface QrInstallModalProps {
    open: boolean
    onClose: () => void
}

/**
 * Centered modal showing a QR code the user can scan from their phone to install
 * the SpotFinder mobile app. Opened from the "Install app" action on the Mobile
 * app notification row in CreateEditRadarModal.
 */
export const QrInstallModal: React.FC<QrInstallModalProps> = ({ open, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ className: 'rounded-xl' }}>
            <DialogContent className={`p-5 ${C.card}`}>
                <div className="flex items-center justify-between mb-3">
                    <h3 className={`text-[15px] font-semibold ${C.heading}`}>Scan QR code</h3>
                    <button type="button" onClick={onClose} className="p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-800" aria-label="Close">
                        <CloseIcon sx={{ fontSize: 16 }} className={C.muted} />
                    </button>
                </div>

                <p className={`text-[12px] ${C.label} mb-4 leading-relaxed`}>Scan this QR code with your camera app to install SpotFinder mobile app</p>

                <div className="flex justify-center mb-4">
                    <img src="/qr-spotfinder.png" alt="Install SpotFinder" className="w-56 h-56 rounded-lg" />
                </div>

                <div className="flex items-start gap-2 p-2.5 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800/30">
                    <WarningAmberIcon sx={{ fontSize: 14 }} className="text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />
                    <p className="text-[11px] text-amber-800 dark:text-amber-300 leading-relaxed">Use the same email on mobile you used on the web</p>
                </div>
            </DialogContent>
        </Dialog>
    )
}
